import isString from "lodash/isString";

export const formatPhone = (value) => {
  // `phone` is `str | int | None` on the LOS models, so a record written from a
  // spreadsheet or an import can hold the number as an INT. Rejecting those
  // made the phone vanish from the row entirely rather than render unformatted.
  if (!value && value !== 0) return "";
  if (!isString(value)) {
    if (typeof value !== "number" || !Number.isFinite(value)) return "";
    value = String(value);
  }
  // Remove all non-digits
  const digits = value.replace(/[^\d]/g, "");

  // Format as (XXX) XXX-XXXX if more than 6 digits
  if (digits.length > 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(
      6,
      10
    )}`;
  }
  // Format as (XXX) XXX if between 4 and 6 digits
  if (digits.length > 3) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  }
  return digits;
};
